import { useState, useEffect } from "react";
import { getWatchListData } from "./watch-list-service";
import { WatchListDataModel } from "./types";

const useWatchListData = (id: string | undefined) => {
  const [data, setData] = useState<WatchListDataModel | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const result = await getWatchListData(id);
        setData(result);
      } catch (err) {
        setError(err instanceof Error ? err : new Error("An error occurred"));
      } finally {
        setIsLoading(false);
      }
    };

    if (id && id !== "") fetchData();
  }, [id]);

  const mutate = async () => {
    try {
      const result = await getWatchListData(id);
      setData(result);
    } catch (err) {
      setError(err instanceof Error ? err : new Error("An error occurred"));
    }
  };

  return {
    data: data?.results,
    isLoading,
    error,
    mutate,
  };
};

export default useWatchListData;
